import { render, staticRenderFns } from "./ReviewCreativeCarousel.vue?vue&type=template&id=35fc3d31&scoped=true&"
import script from "./ReviewCreativeCarousel.vue?vue&type=script&lang=js&"
export * from "./ReviewCreativeCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCreativeCarousel.vue?vue&type=style&index=0&id=35fc3d31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc3d31",
  null
  
)

export default component.exports